<script>
import FullCalendar from '@fullcalendar/vue'
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import ruLocale from '@fullcalendar/core/locales/ru';
import Swal from 'sweetalert2'

export default {
    components: {
        FullCalendar
    },
    data: function () {
        return {
            calendarOptions: {
                plugins: [resourceTimeGridPlugin],
                initialView: 'resourceTimeGridDay',
                schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
                locale: ruLocale,
                themeSystem: 'bootstrap',
                slotMinTime: "07:00:00",
                slotMaxTime: "21:00:00",
                headerToolbar: {
                    start: 'today',
                    center: 'title',
                    end: 'prev,next'
                },
                titleFormat: {year: 'numeric', month: 'long', day: 'numeric', weekday: 'long'},
                nowIndicator: true,
                events: '/api/calendar/events',
                resources: '/api/calendar/resources',
                refetchResourcesOnNavigate: true,
                slotLabelFormat: {
                    hour: 'numeric',
                    minute: '2-digit',
                    omitZeroMinute: false,
                    meridiem: 'short'
                },
                allDaySlot: false,
                displayEventEnd: false,
                eventClick: function (info) {
                    let additional = info.event.extendedProps.additionalinfo;
                    let client = info.event.title;
                    let department = additional.department;
                    let employee;
                    if (additional.employee !== null) {
                        employee = additional.employee;
                    } else {
                        employee = 'Свободный мастер';
                    }
                    let eventDate = additional.date;
                    let eventTime = additional.time;
                    let eventTimeEnd = '';
                    if (additional.time_end !== null) {
                        eventTimeEnd = additional.time_end;
                    }
                    let comment;
                    if (additional.comment !== null) {
                        comment = additional.comment;
                    }

                    Swal.fire({
                        icon: 'info',
                        html:
                            `<div class="row justify-content-center">
                                <div class="col-auto">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td class="text-right align-top"><strong>Клиент: </strong></td>
                                                <td class="text-left">${client}</td>
                                            </tr>
                                            <tr>
                                                <td class="text-right align-top"><strong>Услуга: </strong></td>
                                                <td class="text-left">${department}</td>
                                            </tr>
                                            <tr>
                                                <td class="text-right align-top"><strong>Мастер: </strong></td>
                                                <td class="text-left">${employee}</td>
                                            </tr>
                                            <tr>
                                                <td class="text-right align-top"><strong>Дата: </strong></td>
                                                <td class="text-left">${eventDate}</td>
                                            </tr>
                                            <tr>
                                                <td class="text-right align-top"><strong>Время (с): </strong></td>
                                                <td class="text-left">${eventTime}</td>
                                            </tr>
                                            <tr>
                                                <td class="text-right align-top"><strong>Время (до): </strong></td>
                                                <td class="text-left">${eventTimeEnd}</td>
                                            </tr>
                                            <tr>
                                                <td class="text-right align-top"><strong>Коментарии: </strong></td>
                                                <td class="text-left">${comment !== undefined ? comment : ''}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>`
                        ,
                        showCloseButton: false,
                        confirmButtonText: 'Закрыть'
                    })
                }
            }
        }
    },
    methods: {
        calendarDateFilter(e) {
            const selectedDate = e.target.value;
            let calendarApi = this.$refs.fc.getApi();
            calendarApi.gotoDate(selectedDate);
        }
    }
}
</script>
<template>
    <div>
        <div class="d-flex mb-3 ml-auto">
            <label class="ml-auto font-weight-bold" for="filterDateId">Фильтровать по дате:
                <input type="date" name="filterDate" id="filterDateId" @change="calendarDateFilter"/>
            </label>
        </div>
        <FullCalendar ref="fc" :options="calendarOptions"/>
    </div>
</template>
